import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DischargeCodesComponent } from './discharge-codes.component';
const routes: Routes = [{ path: '', component: DischargeCodesComponent }];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class  DischargeCodesRoutingModule { }
